import faker from 'faker';

import { IHoleScore, IScore, IScoresStore } from './store';

export const getHoleScoreMock = (partial?: Partial<IHoleScore>): IHoleScore => ({
  game: faker.random.number({ max: 100, min: 1 }),
  gross: faker.random.number({ max: 100, min: 1 }),
  handicap: faker.random.number({ max: 100, min: 1 }),
  holeHandicap: faker.random.number({ max: 100, min: 1 }),
  holePar: faker.random.number({ max: 100, min: 1 }),
  id: faker.random.number({ max: 100, min: 1 }),
  net: faker.random.number({ max: 100, min: 1 }),
  order: faker.random.number({ max: 100, min: 1 }),
  original: faker.random.number({ max: 100, min: 1 }),
  ...partial
});

export const getScoreMock = (groupId?: number): IScore => ({
  enrollment: faker.random.number({ max: 100, min: 1 }),
  grossScore: faker.random.number({ max: 100, min: 1 }),
  group: groupId ? groupId : faker.random.number({ max: 100, min: 1 }),
  handicap: faker.random.number({ max: 100, min: 1 }),
  id: faker.random.number({ max: 100, min: 1 }),
  netScore: faker.random.number({ max: 100, min: 1 }),
  qualified: true,
  round: faker.random.number({ max: 100, min: 1 }),
  scores: [getHoleScoreMock()],
  seat: faker.random.number({ max: 100, min: 1 }),
  status: faker.random.word()
});

export const getScoresStoreMock = (): IScoresStore => ({
  1: [getScoreMock(1)]
});
